const layout = () => import('@/views/layout')
// const myAccount = () => import('@/views/account/myAccount')
const verPhone = () => import('@/views/account/verPhone')
const changeBindPhone = () => import('@/views/account/changeBindPhone')

export default [
  {
    path: '/account',
    name: 'account',
    redirect: '/account/myAccount',
    component: layout,
    hidden: true,
    children: [
      // { path: 'my-account', name: 'my-account', component: myAccount, hidden: true, meta: { title: '我的账号', scrollToTop: true } },
      { path: 'verPhone', name: 'verPhone', component: verPhone, hidden: true, meta: { title: '验证原手机号', scrollToTop: true } },
      { path: 'changeBindPhone', name: 'changeBindPhone', component: changeBindPhone, hidden: true, meta: { title: '换绑手机号', scrollToTop: true } },
    ]
  }
]